import {memo} from 'react';

import type {SVGProps} from 'react';

export const SparklesIcon = memo(function SparklesIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={40}
      height={40}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g fill="none">
        <path
          d="M31.7499 18.875L28.9416 17.625V15.9916L25.8332 14.125L25.2332 15.1666C24.2582 14.175 23.4666 13 22.9166 11.675L21.6749 8.69162C21.2166 7.58329 19.6832 7.58329 19.2249 8.69162L17.9832 11.675C16.9166 14.25 14.9166 16.3083 12.4166 17.425L9.15823 18.875C8.09156 19.35 8.09156 20.9083 9.15823 21.3833L12.5249 22.875C13.8416 23.4583 15.0082 24.3166 15.9916 25.3583L15.7999 27.9833L17.9832 28.3416C17.9832 28.3416 18.0166 28.4 18.0249 28.4333L19.2499 31.2333C19.7166 32.3083 21.2082 32.3083 21.6832 31.2333L22.9082 28.4333C23.9999 25.9416 25.9582 23.9583 28.3999 22.875L31.7666 21.3833C32.8332 20.9083 32.8332 19.35 31.7666 18.875H31.7499Z"
          fill="var(--icon-fill-cyan)"
        />
        <path
          d="M33.5418 37.2832L33.2001 38.0666C32.9501 38.6416 32.1585 38.6416 31.9085 38.0666L31.5668 37.2832C30.9585 35.8916 29.8668 34.7832 28.5001 34.1749L27.4501 33.7082C26.8835 33.4582 26.8835 32.6332 27.4501 32.3749L28.4418 31.9332C29.8418 31.3082 30.9585 30.1582 31.5501 28.7249L31.9001 27.8832C32.1418 27.2916 32.9585 27.2916 33.2001 27.8832L33.5501 28.7249C34.1501 30.1666 35.2585 31.3166 36.6585 31.9332L37.6501 32.3749C38.2168 32.6249 38.2168 33.4499 37.6501 33.7082L36.6001 34.1749C35.2335 34.7832 34.1418 35.8916 33.5335 37.2832H33.5418Z"
          fill="var(--icon-fill-cyan)"
        />
        <path
          d="M22.0831 21.8083C21.0581 22.8083 20.2248 24.0167 19.6331 25.3583L18.3748 28.2417C17.8914 29.35 16.3581 29.35 15.8748 28.2417L14.6164 25.3583C13.4914 22.7917 11.4748 20.7417 8.9581 19.625L5.49144 18.0833C4.39144 17.5917 4.39144 15.9917 5.49144 15.5L8.84977 14.0083C10.0248 13.4833 11.0914 12.7583 12.0081 11.875"
          stroke="var(--icon-stroke-cyan)"
          strokeWidth={2.73438}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.5833 8.10002L15.8583 5.02502C16.3333 3.88336 17.9083 3.88336 18.3833 5.02502L19.6583 8.10002C20.7583 10.7584 22.8167 12.875 25.4 14.025L28.7583 15.5167C29.8583 16.0084 29.8583 17.6084 28.7583 18.1L25.2917 19.6417"
          stroke="var(--icon-stroke-cyan)"
          strokeWidth={2.73438}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M26.1584 31.275L25.15 30.825C24.6084 30.5833 24.6084 29.7917 25.15 29.55L26.1 29.125C27.4417 28.525 28.5084 27.425 29.0834 26.0417L29.4167 25.2333C29.65 24.6667 30.4334 24.6667 30.6667 25.2333L31 26.0417C31.575 27.425 32.6417 28.525 33.9834 29.125L34.9334 29.55C35.475 29.7917 35.475 30.5833 34.9334 30.825L33.925 31.275C32.6167 31.8583 31.5667 32.9167 30.9834 34.2583L30.6584 35.0083C30.4167 35.5583 29.6584 35.5583 29.425 35.0083L29.1 34.2583"
          stroke="var(--icon-stroke-cyan)"
          strokeWidth={2.73438}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
});
